// TODO: modules/ should not depend on code from @apps. Do:
// * move localization to separate NX module?
// * move helper either to separate NX module or core/?
import { i18n } from '@apps/main/modules/localization/localizationSetup';

import type { AppSingleSelectOption } from '@libs/ui';
import { textFormaterByLocale } from '@libs/utils';

const { t } = i18n.global;

export function getNightsOptions(): AppSingleSelectOption<number>[] {
  const maxNumberOfNights = 100;

  return Array.from({ length: maxNumberOfNights }, (_, i) => {
    const nightCount = i;
    return {
      id: nightCount,
      label: `${nightCount} ${textFormaterByLocale(
        t('planner.nights', nightCount)
      )}`,
    };
  });
}
